import React from "react";
import {
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
  render() {
    const searchValues = this.props.selectedSearchValues;
    const tableData = this.props.tableData;
    const TotalAmount = this.props.TotalAmount;

    const cellStyle = {
      border: '1px solid black',
      padding: '1px',
      fontSize: '0.9rem',
    };

    return (
      <div>
        <h2><center><u>Supplier Due Cheque Detail Report</u></center></h2>
        <div>&nbsp;</div>
        <h3><center>Group : {searchValues.groupName}</center></h3>
        <h3><center>Factory : {searchValues.factoryName}</center></h3>
        <h3><center>Date : {(new Date(searchValues.selectedDate)).toLocaleDateString()}</center></h3>
        <div>&nbsp;</div>
        <Box minWidth={1050} display="flex" justifyContent="flex-end" p={2}>
          <TableContainer style={{ marginTop: 16, padding: 8, paddingBottom: '20px' }}>
            <Table size="small" aria-label="report table" style={{ borderCollapse: 'collapse', width: '100%' }}>
              <TableHead>
                <TableRow>
                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Registration Number</TableCell>
                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Customer Name</TableCell>
                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Issuing Date</TableCell>
                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Due Date</TableCell>
                  <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Amount (Rs.)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData && tableData.map((item, idx) => (
                  <TableRow key={idx}>
                     <TableCell align="left" style={{ border: "1px solid black" }}>{item.registrationNumber}</TableCell>
                     <TableCell align="left" style={{ border: "1px solid black" }}>{item.customerName}</TableCell>
                     <TableCell align="center" style={{ border: "1px solid black" }}>{item.issuingDate ? item.issuingDate.substring(0, 10) : ""}</TableCell>
                     <TableCell align="center" style={{ border: "1px solid black" }}>{item.dueDate ? item.dueDate.substring(0, 10) : ""}</TableCell>
                     <TableCell align="right" style={{ border: "1px solid black" }}>{item.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableRow style={{ border: '1px solid black' }}>
               <TableCell colSpan={3} align="left" style={{ border: '1px solid black' }}><b>Total</b></TableCell>
                <TableCell align={'right'} component="th" scope="row" style={{ border: '1px solid black' }} colSpan={4}>
                  <b>
                    {(TotalAmount && TotalAmount.amount != null)
                      ? TotalAmount.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                      : "0.00"}
                  </b>
                </TableCell>
              </TableRow>
            </Table>
          </TableContainer>
        </Box>
        <div>&nbsp;</div>
      </div>
    );
  }
}